import script from "./ModalBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBase.vue?vue&type=script&setup=true&lang=js"

import "./ModalBase.vue?vue&type=style&index=0&id=89b68388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b68388"]])

export default __exports__